import React, { Component } from 'react';
import { connect } from 'react-redux';
import LayoutSplashScreen from '../../../../_metronic/layout/Layout';
import { persistor } from '../../../store/store';

import * as auth from '../_redux/authRedux';

class Logout extends Component {
    componentDidMount () {
        localStorage.setItem('demo1-lastLocation', '');
        localStorage.setItem('demo1-lastLocation_expiresIn', '');
        localStorage.clear();
        persistor.purge().then(() => {
            window.location.href = '/auth/login';
        })
            .catch(err => {
                console.error('We could not delete the persist data', err);
                window.location.href = '/auth/login';
            });
        // this.props.logout();
    }

    render () {
        return <LayoutSplashScreen />;
    }
}

export default connect(
    ({ auth }) => ({ hasAuthToken: Boolean(auth.authToken) }),
    auth.actions
)(Logout);
